export default __webpack_public_path__ + "static/g2icon-c96f196f0099f02dccedc489eea27ba9.svg";